import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { RatingBadge } from 'site-modules/core-page/components/rating-badge/rating-badge';

import './preprod-score.scss';

const FIRST_IMPRESSION_SCORE_RATING_VERSION = '4.1';

export function PreprodScore({ className = null, firstImpressionScore = null }) {
  if (!firstImpressionScore) {
    return null;
  }

  return (
    <div
      className={classnames('preprod-score d-flex align-items-center', className)}
      data-tracking-parent="preprod-rating"
    >
      <div className="medium fw-bold text-center ps-0_5 pe-1_25 border-right text-nowrap">
        Edmunds
        <br />
        First Impression
        <RatingBadge
          className="mt-0_5"
          editorialRating={firstImpressionScore}
          isScorecardV4
          ratingVersion={FIRST_IMPRESSION_SCORE_RATING_VERSION}
          hideRatingText
          hideTestedText
        />
      </div>
      <div className="ps-0_75 small">
        <span className="fw-bold">We drove it.</span> This is a preliminary score based on our initial drive. Our
        official Edmunds Rating will be published after thoroughly testing the vehicle.
      </div>
    </div>
  );
}

PreprodScore.propTypes = {
  className: PropTypes.string,
  firstImpressionScore: PropTypes.number,
};
